<div class="tradegpt-container d-flex overflow-hidden">
  <!-- Main Chat Section -->
  <div class="flex-grow-1 d-flex flex-column main-chat-area h-100">

    <!-- Chat Header -->
    <!-- <div class="chat-header d-flex align-items-center justify-content-between px-4 py-3 border-bottom flex-shrink-0">
      <div class="d-flex align-items-center gap-2">
        <span class="fw-medium semi-boldb" style="color: #080B53;">Trade GPT</span>
        <i class="bi bi-chevron-right text-muted" style="font-size: 0.7rem;"></i>
        <span class="small fw-semibold text-dark">New Conversation</span>
      </div>
      <div class="d-flex align-items-center gap-3">
        <div class="position-relative" role="button" (click)="toggleHistory()" title="History">
          <i class="bi bi-bell text-secondary fs-5"></i>
          @if(hasNotifications) {
          <span
            class="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle notification-dot"></span>
          }
        </div>
        <i class="bi bi-question-circle text-secondary fs-5" role="button" title="Help"></i>
      </div>
    </div> -->

    <!-- Scrollable Chat Content -->
    <div class="chat-content-wrapper flex-grow-1 overflow-auto p-4 custom-scrollbar" #chatContainer>
      <!-- Landing State (Always Visible) -->
      <div class="landing-content d-flex flex-column align-items-center text-center py-5" 
           [ngClass]="{'h-100 justify-content-center': !chat && chatHistory.length === 0}">
        <div class="center-icon-box shadow-sm mb-4">
          <img src="tradegpt-icon.svg" style="z-index:10">
        </div>
        <h1 class="landing-title mb-2">How can I help you trade today?</h1>
        <p class="landing-subtitle mb-5 px-3">Ask about market prices, shipment schedules, supplier
          ratings, or get help placing complex orders instantly.</p>

        <!-- Quick Action Cards Grid -->
        <div class="quick-actions-container container-fluid px-4">
          <div class="row g-3 justify-content-center">
            <div class="col-12 col-md-5">
              <div class="quick-card d-flex align-items-center p-3 gap-3" role="button"
                (click)="startQuickSearch('What are the current countries exporting dragon fruit?')">
                <div class="card-icon price-icon"><img src="icons/price-inquiry-icon.svg"></div>
                <div class="text-start">
                  <div class="card-label">Export Market</div>
                  <div class="card-hint text-muted">"What are the current countries exporting dragon fruit?"</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-5">
              <div class="quick-card d-flex align-items-center p-3 gap-3" role="button"
                (click)="startQuickSearch('Which apple varieties are most imported into India?')">
                <div class="card-icon logistics-icon"><img src="icons/logistics-icon.svg"></div>
                <div class="text-start">
                  <div class="card-label">Import Trends</div>
                  <div class="card-hint text-muted">"Which apple varieties are most imported into India?"</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-5">
              <div class="quick-card d-flex align-items-center p-3 gap-3" role="button"
                (click)="startQuickSearch('From where does India import blueberries?')">
                <div class="card-icon vetting-icon"><img src="icons/supplier-vetting-icon.svg"></div>
                <div class="text-start">
                  <div class="card-label">Import Sources</div>
                  <div class="card-hint text-muted">"From where does India import blueberries?"</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-5">
              <div class="quick-card d-flex align-items-center p-3 gap-3" role="button"
                (click)="startQuickSearch('How do i start trading fruits on agrify.ai?')">
                <div class="card-icon ordering-icon"><img src="icons/ordering-icon.svg"></div>
                <div class="text-start">
                  <div class="card-label">Trading Support</div>
                  <div class="card-hint text-muted">"How do i start trading fruits on agrify.ai?"</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Active Chat State -->
      <div class="messages-list mx-auto mt-2" style="max-width: 1000px;" #messagesList>
        @if(chat || chatHistory.length > 0) {
          <div class="text-center text-muted mb-4 mt-2" style="font-size: 13px;">Today</div>
        }

        <!-- Single chat if available (from route state) -->
        @if(chat) {
        <div class="message-group mb-5">
          <div class="user-message-row d-flex justify-content-end align-items-end mb-4 group">
            <div class="user-bubble px-4 py-3 shadow-sm">
              {{ chat.question }}
            </div>
            <div class="user-avatar-circle ms-3 shadow-sm">
              <i class="bi bi-person-fill"></i>
            </div>
          </div>

          <div class="ai-message-row d-flex align-items-start mb-5">
            <!-- <div class="ai-avatar-circle me-3 mt-1 shadow-sm">
              <i class="bi bi-robot"></i>
            </div> -->
            <div class="ai-bubble-container flex-grow-1">
              <div class="ai-bubble p-4 shadow-sm border rounded-4 bg-white">
                <div class="answer-content text-dark" [innerHTML]="formatAnswer(chat.answer)" style="line-height: 1.6;">
                </div>
                @if(chat.answer) {
                <div class="bubble-actions mt-3 pt-3 border-top d-flex gap-2">
                  <button class="btn btn-action-pill btn-sm px-3">Request Quotes</button>
                  <button class="btn btn-action-pill btn-sm px-3">View Catalogs</button>
                </div>
                }
              </div>
              <div class="message-footer-tools d-flex gap-3 mt-2 px-1 text-muted">
                <i class="bi bi-hand-thumbs-up" role="button" title="Helpful"></i>
                <i class="bi bi-hand-thumbs-down" role="button" title="Not helpful"></i>
                <i class="bi bi-copy ms-auto" role="button" title="Copy response"
                  (click)="copyQuestion(chat.answer)"></i>
              </div>
            </div>
          </div>
        </div>
        }

        <!-- History items loaded in session -->
        @for(item of chatHistory; track $index; let i = $index) {
        <div class="message-group mb-5">
          <div class="user-message-row d-flex justify-content-end align-items-end mb-4">
            <div class="user-bubble px-4 py-3 shadow-sm">
              {{ item.question }}
            </div>
            <div class="user-avatar-circle ms-3 shadow-sm">
              <i class="bi bi-person-fill"></i>
            </div>
          </div>

          <div class="ai-message-row d-flex align-items-start mb-5" style="width:90%">
            <!-- <div class="ai-avatar-circle me-3 mt-1 shadow-sm">
              <i class="bi bi-robot"></i>
            </div> -->
            <div class="ai-bubble-container flex-grow-1">
              <div class="ai-bubble p-4 shadow-sm border rounded-4 bg-white">
                @if(item.answer === '') {
                <div class="thinking-loader d-flex align-items-center gap-2">
                  <span class="fw-medium text-secondary">Thinking&nbsp;&nbsp;</span>
                  <div class="dot-flashing"></div>
                </div>
                } @else {
                <div class="answer-content text-dark" [innerHTML]="formatAnswer(item.answer)" style="line-height: 1.6;"></div>
                }
              </div>
              @if(item.answer !== '') {
              <div class="message-footer-tools d-flex gap-3 mt-2 px-1 text-muted">
                <i class="bi bi-hand-thumbs-up" role="button" title="Helpful"></i>
                <i class="bi bi-hand-thumbs-down" role="button" title="Not helpful"></i>
                <i class="bi bi-copy ms-auto" role="button" title="Copy" (click)="copyQuestion(item.answer)"></i>
              </div>
              }
            </div>
          </div>
        </div>
        }
      </div>
    </div>

    <div class="chat-input-wrapper border-top py-4 px-5 flex-shrink-0 bg-white pb-5 mb-5 mb-lg-0">
      <div class="input-inner-container mx-auto" style="max-width:100%;">
        <form (ngSubmit)="search()" class="position-relative">
          <div class="custom-input-box shadow-sm border rounded-3 d-flex flex-column p-4 pb-3">
            <textarea class="form-control border-0 shadow-none bg-transparent p-0 mb-4" id="input-field" #targetInput
              placeholder="Ask about bulk fruit pricing, verified suppliers, export logistics, investor deals, or shipment tracking..."
              [(ngModel)]="inputField" name="inputField" rows="2" (keydown.enter)="$event.preventDefault(); search()"
              style="resize: none; font-size: 1rem; line-height: 1.5; color: #4B5563;"></textarea>
            <div class="d-flex justify-content-end  mt-auto">
              <!-- <div class="input-left-tools d-flex gap-3">
                <i class="bi bi-paperclip text-secondary fs-5" role="button" title="Attach file"></i>
                <i class="bi bi-mic text-secondary fs-5" role="button" title="Voice input"></i>
              </div> -->
              <button type="submit" class="send-message-btn-square border-0" [disabled]="!inputField || loading">
                <i class="bi bi-send-fill"></i>
              </button>
            </div>
          </div>
        </form>
        <p class="text-center text-muted mt-3 mb-1" style="font-size: 0.75rem; opacity: 0.9;">
          Agrify.ai provides AI-assisted trade insights. Always verify pricing, certifications, and compliance before
          confirming transactions.
        </p>
      </div>
    </div>
  </div>


</div>